<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-responsive max-width="2160px" width="100%">
                <v-row class="mt-8" justify="center" align="center">
                    <v-col cols="auto" class="pt-0 pb-0 headline text-start">배송상품 목록</v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="pt-0 pb-0">
                        <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                    </v-col>
                </v-row>

                <product-list-search />

                <v-row class="mt-4" center="end">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn v-bind="{ loading }" color="white" class="green--text px-2 ml-1" @click="excel">
                            <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon
                            >엑셀다운로드
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table :loading="loading" :headers="productsHeaders" :items="products" item-key="_id" disable-sort disable-pagination hide-default-footer class="elevation-1">
                    <template #[`item.no`]="{ item }">
                        <product-no-edit :value="item" v-on="{ update }">
                            {{ item.no }}
                        </product-no-edit>
                    </template>
                    <template #[`item.product`]="{ item }">
                        <v-row align="center">
                            <v-col md="auto" class="py-0">
                                <v-img v-if="item.thumb" :src="item.thumb" contain max-width="96" max-height="96"></v-img>
                                <v-responsive v-else width="96" height="96">
                                    <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                        <v-icon>mdi-image</v-icon>
                                    </v-row>
                                </v-responsive>
                            </v-col>
                            <v-col>
                                <div class="text-start">{{ item.name }}</div>
                            </v-col>
                        </v-row>
                    </template>
                    <template #[`item.supplyPrice`]="{ item }"> {{ item?.supplyPrice?.format?.() }}원 </template>
                    <template #[`item.costPrice`]="{ item }"> {{ item?.costPrice?.format?.() }}원 </template>
                    <template #[`item.salePrice`]="{ item }"> {{ item?.salePrice?.format?.() }}원 </template>
                    <template #[`item.stock`]="{ item }">
                        {{ item?.stock?.format?.() }}
                    </template>
                    <template #[`item.isTaxFree`]="{ item }">
                        <v-switch v-model="item.isTaxFree" :disabled="!$hasScope(['root', 'admin'])" v-bind="{ inset: true, hideDetails: 'auto' }" class="pa-0 ma-0 d-inline-block mr-n2" @change="update({ _id: item._id, isTaxFree: item.isTaxFree, updateOptions: true })" />
                    </template>
                    <template #[`item.onSale`]="{ item }">
                        <v-switch v-model="item.onSale" :disabled="!$hasScope(['root', 'admin'])" v-bind="{ inset: true, hideDetails: 'auto' }" class="pa-0 ma-0 d-inline-block mr-n2" @change="update({ _id: item._id, onSale: item.onSale })" />
                    </template>
                    <template #[`item.soldout`]="{ item }">
                        <v-switch v-model="item.soldout" :disabled="!$hasScope(['root', 'admin'])" v-bind="{ inset: true, hideDetails: 'auto' }" class="pa-0 ma-0 d-inline-block mr-n2" @change="update({ _id: item._id, soldout: item.soldout })" />
                    </template>
                    <template #[`item.onDisplay`]="{ item }">
                        <v-switch v-model="item.onDisplay" :disabled="!$hasScope(['root', 'admin'])" v-bind="{ inset: true, hideDetails: 'auto' }" class="pa-0 ma-0 d-inline-block mr-n2" @change="update({ _id: item._id, onDisplay: item.onDisplay })" />
                    </template>
                    <template #[`item.actions`]="{ item }">
                        <v-icon small @click="edit(item)" title="수정">mdi-pencil</v-icon>
                        <!-- <v-icon small @click="copy(item)" title="복사" class="ml-4">mdi-content-copy</v-icon> -->
                        <v-icon v-if="$hasScope(['root', 'admin'])" small @click="remove(item)" title="삭제" class="ml-4">mdi-delete</v-icon>
                    </template>
                </v-data-table>
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="(page) => $router.push({ query: { ...params, page } })"></v-pagination>

                <v-btn bottom color="accent" fab fixed right @click="create">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </v-responsive>
        </v-layout>
    </v-container>
</template>
  
  <script>
import api from "@/api";
import XLSX from "xlsx";
import download from "downloadjs";
import { mdiMicrosoftExcel } from "@mdi/js";
import CategorySelect from "@/components/console/shop/categories/category-select.vue";
import ProductListSearch from "@/components/console/shop/delivery/products/product-list-search.vue";
import ProductNoEdit from "@/components/console/shop/delivery/products/product-no-edit.vue";

export default {
    components: {
        CategorySelect,
        ProductListSearch,
        ProductNoEdit,
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            mdiMicrosoftExcel,
            showSearch: true,
            loading: false,
            productsHeaders: [
                { text: "no", align: "center", value: "no" },
                { text: "코드", align: "center", value: "code" },
                { text: "상품", align: "center", value: "product" },
                { text: "공급가", align: "center", value: "supplyPrice" },
                { text: "소비자가", align: "center", value: "costPrice" },
                { text: "판매가", align: "center", value: "salePrice" },
                { text: "재고", align: "center", value: "stock" },
                { text: "면세", align: "center", value: "isTaxFree" },
                { text: "품절", align: "center", value: "soldout" },
                { text: "판매상태", align: "center", value: "onSale" },
                { text: "전시상태", align: "center", value: "onDisplay" },
                { text: "actions", align: "center", value: "actions" },
            ],
            limit: 15,
            summary: { totalCount: 0 },

            categories: [],
            products: [],
        };
    },
    computed: {
        page() {
            return +(this.$route.query.page || "1");
        },
        params() {
            let { ...params } = this.$route.query;
            return params;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
    },
    methods: {
        download,
        async init() {
            this.search();
        },
        async search() {
            try {
                if (this.loading) return;
                this.loading = true;
                let { summary, products } = await api.console.shop.delivery.products.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.params,
                });

                this.loading = false;
                this.products = products;
                this.summary = summary;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },
        create() {
            this.$router.push(`${this.$route.path}/create`);
        },
        // copy(product) {
        //     this.$router.push(`${this.$route.path}/copy?_product=${product._id}`);
        // },
        edit(product) {
            this.$router.push(`${this.$route.path}/${product._id}`);
        },

        async update({updateOptions = false, _id, ...form}) {
            try {
                if (this.loading) return;
                this.loading = true;

                const { product } = await api.console.shop.delivery.products.put({_id, ...form});

                if(updateOptions && product?.optionalProducts?.length) {
                    for (const optionalProduct of product.optionalProducts) {
                        await api.console.shop.delivery.products.put({ ...optionalProduct, ...form });
                    }
                }

                this.loading = false;
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        async excel() {
            if (this.loading) return;
            this.loading = true;
            var { products } = await api.console.shop.delivery.products.gets({ headers: { limit: 0 }, params: this.filter });

            var rows = [];
            products.forEach((product) => {
                rows.push({
                    no: product.no,
                    상품코드: product.code,
                    상품명: product.name,
                    공급가: product.supplyPrice.format(),
                    소비자가: product.costPrice.format(),
                    할인: `${product.discountAmount}${product.discountUnit === "percent" ? "%" : "원"}`,
                    판매가: product.salePrice.format(),
                    재고: product.stock,
                    품절: product.soldout ? "예" : "아니요",
                    면세여부: product.isTaxFree ? "면세" : "과세",
                    판매상태: product.onSale ? "예" : "아니요",
                    전시상태: product.onDisplay ? "예" : "아니요",
                    베스트: product.isBest ? "예" : "아니요",
                    추천상품: product.isRecommend ? "예" : "아니요",
                    신상품: product.isNewly ? "예" : "아니요",
                    인기상품: product.isPopular ? "예" : "아니요",
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, `배송상품 목록_${this.$dayjs().format("YYYYMMDD_HHmmss")}.xlsx`);

            this.loading = false;
        },

        async remove(product) {
            if (confirm("해당 상품을 삭제하시겠습니까?")) {
                await api.console.shop.delivery.products.put({ _id: product._id, isDeleted: true, deletedAt: Date.now() });
                alert("삭제되었습니다");
                await this.search();
            }
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
};
</script>